// extracted by mini-css-extract-plugin
module.exports = {"notificationContainer":"NotificationPage_notificationContainer__20IlV","newNotificationContainer":"NotificationPage_newNotificationContainer__2htuj"};